import type { ToastContent, ToastOptions } from 'react-toastify';

// eslint-disable-next-line no-restricted-imports
import {
  toast as baseToast,
  cssTransition,
  ToastContainer,
  Zoom,
} from 'react-toastify';

/**
 * Second encapsulation of react-toastify to prevent displaying same toast message repeatedly
 */
const toast = {
  ...baseToast,
  error: <TData = unknown>(
    content: ToastContent<TData>,
    options?: ToastOptions
  ) => baseToast.error(content, { toastId: String(content), ...options }),

  info: <TData = unknown>(
    content: ToastContent<TData>,
    options?: ToastOptions
  ) => baseToast.info(content, { toastId: String(content), ...options }),

  loading: <TData = unknown>(
    content: ToastContent<TData>,
    options?: ToastOptions
  ) => baseToast.loading(content, { toastId: String(content), ...options }),

  success: <TData = unknown>(
    content: ToastContent<TData>,
    options?: ToastOptions
  ) => baseToast.success(content, { toastId: String(content), ...options }),

  warn: <TData = unknown>(
    content: ToastContent<TData>,
    options?: ToastOptions
  ) => baseToast.warn(content, { toastId: String(content), ...options }),
};

const NoTransition = cssTransition({
  collapseDuration: 0,
  enter: 'Toastify__none-enter',
  exit: 'Toastify__none-exit',
});

export { NoTransition, toast, ToastContainer, Zoom };
